import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as MDICONS from '@material-ui/icons';
import GridSettings from './widgets/GridSettings';
import ErrorComponent from '../../error/ErrorComponent';
import FloorEditor from './editor/FloorEditor';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import ReactModal from 'react-modal';
import Loader from 'react-loader-spinner';
import styled from 'styled-components';
import { floor, get } from 'lodash'
import { testUpdateFloorMarkersInDatastore, updateFloorMarkersInDatastore } from '../../../store/actions/datastoreActions';
import NewMarkerWrapper from '../markers/newMarker/NewMarkerWrapper';
import * as ROUTES from '../../../constants/routes';
import { Link } from 'react-router-dom';
import MapGuide from '../MapGuide';
import MaplessGuide from '../MaplessGuide';

class FloorPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            // EDIT MARKER CONTROL
            viewBriefToggle: true,

            // POINTER HINT CONTROL
            pointerHintToggle: false,

            // GRID CONTROL
            showGridModal: false, gridToggle: true, gridSize: 25,

            showGuideModal: false,
            showGuideModalMapless: false,
        }
    }

    /// README: VIEW BRIEF MARKER TOGGLE FUNCTION
    toggleBriefMarker = () => {
        this.setState({
            viewBriefToggle: !this.state.viewBriefToggle
        })
    }

    /// README: HINT POINTER TOGGLE
    togglePointerHint = () => {
        this.setState({
            pointerHintToggle: !this.state.pointerHintToggle
        })
    }

    /// README: GRID FUNCTIONS
    toggleGrid = () => {
        this.setState({
            gridToggle: !this.state.gridToggle
        })
    }

    handleGridSizeChange = (gridSize) => {
        this.setState({
            gridSize,
        })
    }

    /// README: MODAL CONTROL
    handleOpenModal = (num) => {
        // this.setState({ showGridModal: true });
        switch (num) {
            case 0: {
                this.setState({
                    showGuideModal: true,
                })
                break;
            }
            case 1: {
                this.setState({
                    showGuideModalMapless: true,
                })
                break;
            }
            default: {

            }
        }
    }

    handleCloseModal = (num) => {
        switch (num) {
            case 0: {
                this.setState({
                    showGuideModal: false,
                })
                break;
            }
            case 1: {
                this.setState({
                    showGuideModalMapless: false
                })
                break;
            }
            default: {

            }
        }

    }

    /// README: RENDER THE UI
    render() {
        // console.log(this.props.projectProductOrder);
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }

        // Loading data from state and props
        const { viewBriefToggle, pointerHintToggle, gridToggle, gridSize } = this.state;
        const { dashboardSidebarSize, userData, modalStyles, alu, snagDetail, project, projectProductOrder, commonLabels } = this.props;
        const { assetParts, assetPart, uassetParts, uassetPart, defectMarkers, defectMarker } = commonLabels;
        const { floorMeta } = project;
        const { containsMap, name, fileName } = floorMeta;
        const { markerViewingToggleAccess } = alu;
        const { uid, employeeid } = userData;
        if (snagDetail && projectProductOrder) {
            const { accessMap } = snagDetail;
            /// README: CHECKING ACCESS LEVEL FOR RECODING AND EDITING
            /// getting ueid to pass into accessMap of project to get accessLevel
            var ueid = uid + employeeid;
            var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
            var isMarkerViewingToggleAllowed = markerViewingToggleAccess[accessLevel];
            const { tagCount, tagLimit } = projectProductOrder;
            const tagLimitReached = tagCount > tagLimit ? true : false;
            const grid = (gridToggle ?
                (
                    <React.Fragment>
                        <defs>
                            <pattern id="transformedPattern" x="0" y="0" width={gridSize} height={gridSize} patternUnits="userSpaceOnUse">
                                <rect x="0" y="0" width={gridSize} height={gridSize} className="grid-rect" />
                            </pattern>
                        </defs>
                        <rect x="0" y="0" width="100%" height="100%" className="shapes-svg" />
                    </React.Fragment>
                ) : (
                    <React.Fragment></React.Fragment>
                )
            );

            const gridState = gridToggle ? "on" : "off";
            const viewBriefState = viewBriefToggle ? "record" : "view";
            const modeColor = viewBriefToggle ? "darkblue" : "darkgreen";

            // const pointerHintState = pointerHintToggle ? "hint is on, tap to turn off" : "hint is off, tap to turn on";


            return (
                <div className="my-2 mx-2">
                    <div className="" style={{ marginLeft: dashboardSidebarSize, marginTop: '80px' }}>
                        <h5 className="card-header" style={{ textAlign: "start", fontWeight: "normal" }}>
                            <div className="d-flex justify-content-between">
                                {/* LEFT SIDE HEADER ITEMS */}
                                <div className="d-flex flex-row">
                                    <div className="align-self-center">
                                        <div className="d-flex flex-column">
                                            <div className="align-self-start">
                                                {/* VIEW TOGGLE */}

                                                {containsMap || fileName.length > 0 ? isMarkerViewingToggleAllowed ?
                                                    <div className="row">
                                                        <div className="" style={{ float: 'left' }}>
                                                            <span style={{ fontSize: "16px", textAlign: "start" }}>
                                                                <Link to={ROUTES.IND_PROJECT_DASHBOARD} className="btn btn-sm mr-3"><MDICONS.ArrowBackIosRounded /> Go back</Link>
                                                            </span>
                                                            <span className="" style={{ fontSize: "18px", fontWeight: "bold", display: 'inline' }}>{name}</span>
                                                            {tagLimitReached ?
                                                                !pointerHintToggle ? <span disabled className="badge ml-4" style={{ display: 'inline', backgroundColor: `${modeColor}`, color: "whitesmoke", borderRadius: '5px', border: 'none' }} role="button" onClick={() => { this.toggleBriefMarker() }}>switch to {viewBriefState} mode</span> : null
                                                                :
                                                                !pointerHintToggle ? <span className="badge ml-4" style={{ display: 'inline', backgroundColor: `${modeColor}`, color: "whitesmoke", borderRadius: '5px' }} role="button" onClick={() => { this.toggleBriefMarker() }}>switch to {viewBriefState} mode</span> : null
                                                            }
                                                        </div>
                                                    </div>

                                                    // if marker adding toggle not allowed
                                                    : <div style={{ float: 'left' }}>
                                                        <span style={{ fontSize: "16px", textAlign: "start", display: 'inline' }}>
                                                            <Link to={ROUTES.IND_PROJECT_DASHBOARD} className="btn btn-sm mr-3"><MDICONS.ArrowBackIosRounded /> Go back</Link>
                                                        </span>
                                                        <span style={{ fontSize: "18px", fontWeight: "bold", display: 'inline' }}>{name}</span>
                                                    </div>

                                                    // if map doesnot exist so this we will have this condition
                                                    :
                                                    <div style={{ float: 'left' }}>
                                                        <span style={{ fontSize: "16px", textAlign: "start", display: 'inline' }}>
                                                            <Link to={ROUTES.IND_PROJECT_DASHBOARD} className="btn btn-sm mr-3"><MDICONS.ArrowBackIosRounded /> Go back</Link>
                                                        </span>
                                                        <span style={{ fontSize: "18px", fontWeight: "bold", display: 'inline' }}>{name}</span>
                                                    </div>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* RIGHT SIDE HEADER ITEMS */}
                                <div className="d-flex flex-row">
                                    <div className="align-self-center">
                                        <div className="d-flex flex-row">
                                            <div className="align-self-end">

                                                {containsMap || fileName.length > 0 ?
                                                    <div className="d-flex justify-content-between">
                                                        {/* <div className="border-0 w-95">
                                                            <button type="button" className="btn btn-default btn-sm" ><b>Grid {gridState} with size: {gridSize}</b></button>
                                                        </div> */}
                                                        <button className="btn btn-sm" onClick={() => { this.handleOpenModal(0) }}>
                                                            <div><MDICONS.Help style={{ scale: "1" }} /></div>
                                                        </button>
                                                    </div>
                                                    : <button className="btn btn-sm" onClick={() => { this.handleOpenModal(1) }}>
                                                        <div><MDICONS.Help style={{ scale: "1" }} /></div>
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </h5>
                        <FloorEditor grid={grid} viewBriefToggle={viewBriefToggle} pointerHintToggle={pointerHintToggle} tagLimitReached={tagLimitReached} defectMarker={defectMarker} defectMarkers={defectMarkers} />
                    </div>


                    {/* GRID SETTINGS MODAL */}
                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.showGuideModal}
                        onRequestClose={() => { this.handleCloseModal(0) }}
                        contentLabel="Map guide modal"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.handleCloseModal(0) }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <MapGuide />
                    </ReactModal>

                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.showGuideModalMapless}
                        onRequestClose={() => { this.handleCloseModal(1) }}
                        contentLabel="Map guide modal mapless"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.handleCloseModal(1) }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <MaplessGuide />
                    </ReactModal>
                </div>
            )
        }
        else if (snagDetail || projectProductOrder === undefined) {
            return (
                <div className="container-fluid">
                    <div className="" style={{ marginLeft: dashboardSidebarSize, marginTop: '80px' }}>
                        <div className="card p-3 pt-5">
                            <Loader
                                type="TailSpin"
                                color={this.props.themeColors.themeColor}
                                height={50}
                                width={50}
                            />
                            <br></br>
                            <p style={textStyle}>Fetching your asset...</p>
                            <br></br>
                        </div>
                    </div>
                </div>
            )
        }
        else if (snagDetail || projectProductOrder === null) {
            return (
                <div className="container-fluid">
                    <div className="" style={{ marginLeft: dashboardSidebarSize, marginTop: '80px' }}>
                        <div className="card p-3 pt-5">
                            <ErrorComponent />
                        </div>
                    </div>
                </div>
            )
        }
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        userData: state.firebase.profile,
        auth: state.firebase.auth,
        modalStyles: state.appControl.modalStyles,
        alu: state.alu,
        commonLabels: state.commons,
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),

        // project specifics
        projectCompany: state.firestore.data.ProjectCompany,
        projectProductOrder: state.firestore.data.ProjectProductOrder,
    }
}

export default compose(
    connect(mapStateToProps),
    firestoreConnect((props) => {
        var employeeid = props.userData ? props.userData.employeeid : '';
        var ueid = props.auth.uid + employeeid;
        var coid = props.userData.coid;
        const { project } = props;
        const { snagDetail, floorMeta, proid } = project;
        const { accessMap } = snagDetail;

        var hasAllTags = accessMap ? ueid in accessMap ? accessMap[ueid]['hasAllTags'] ?? false : false : false;
        var selectedTagsIdList = accessMap ? ueid in accessMap ? accessMap[ueid]['selectedTagsIdList'] ?? [] : [] : [];
        selectedTagsIdList = selectedTagsIdList.includes('elevation') ? [...selectedTagsIdList] : [...selectedTagsIdList, 'elevation'];
        const { floorid } = floorMeta;

        if (hasAllTags) {
            return [
                {
                    collection: `Projects/${proid}/Markers/`,
                    storeAs: "FloorMarkers",
                    where: [['floorid', '==', `${floorid}`]]

                }
            ]
        } else {
            if (selectedTagsIdList.length !== 0) {
                return [
                    {
                        collection: `Projects/${proid}/Markers/`,
                        storeAs: "FloorMarkers",
                        where: [['floorid', '==', `${floorid}`], ['tags', 'array-contains-any', selectedTagsIdList]]
                        // orderBy: ['deadline','desc']

                    }
                ]

            } else {
                return [
                    {
                        collection: `Projects/${proid}/Markers/`,
                        storeAs: "FloorMarkers",
                        where: [['floorid', '==', '-1'],]

                    }
                ]
            }
        }
    })
)(FloorPage);
